export const showAlert = ({
  severity,
  message,
  setHasError,
  setErrorContent,
}) => {
  setErrorContent({ severity, message });
  setHasError(true);
};
